import { render, staticRenderFns } from "./TimetableList.vue?vue&type=template&id=70589f42"
import script from "../../controllers/timetable/timetable-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/timetable/timetable-list.js?vue&type=script&lang=js&external"
import style0 from "./TimetableList.vue?vue&type=style&index=0&id=70589f42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports